import { sellerName } from '../data/catalog.ts'
import { invoiceStatus, invoiceTotal, type ProtoInvoiceRecord } from '../data/invoices.ts'
import type { ProtoOrder } from '../data/orders.ts'
import { add, sub, toMoney } from '../lib/decimal.ts'
import { TODAY } from '../lib/format.ts'
import { can } from '../lib/permissions.ts'
import { proto } from './store.ts'

export const canSeeInvoices = () => can(proto.role(), 'invoices', 'read')
/** Spec §15: invoices and payment controls stay with Accounting/Admin. */
export const canManageInvoices = () => can(proto.role(), 'invoices', 'update')

export const invoicesOf = (dealId: string) =>
  proto.state.invoices.filter((invoice) => invoice.dealId === dealId)

export const orderOfInvoice = (invoice: ProtoInvoiceRecord) =>
  invoice.dealId ? proto.state.orders.find((order) => order.deal.id === invoice.dealId) : undefined

export const customerOf = (invoice: ProtoInvoiceRecord) =>
  proto.state.customers.find((customer) => customer.id === invoice.customerId)

export const sellerOf = (invoice: ProtoInvoiceRecord) => sellerName(invoice.sellerEntityId)

/** Order amount not yet on any invoice, so nobody bills the same money twice. */
export const uninvoicedOf = (order: ProtoOrder) =>
  toMoney(
    sub(
      order.deal.amount,
      add('0', ...invoicesOf(order.deal.id).map((invoice) => invoiceTotal(invoice))),
    ),
  )

/** Orders an invoice can be raised for: won, with money not yet invoiced. */
export const invoiceableOrders = () =>
  proto.state.orders.filter(
    (order) => order.deal.stageCategory === 'successful' && toUnitsPositive(uninvoicedOf(order)),
  )

const toUnitsPositive = (value: string) => !value.startsWith('-') && value !== '0.00'

export const daysOverdue = (invoice: ProtoInvoiceRecord) =>
  invoiceStatus(invoice) === 'overdue'
    ? Math.floor(
        (Date.parse(`${TODAY}T12:00:00Z`) - Date.parse(`${invoice.dueAt}T12:00:00Z`)) / 86_400_000,
      )
    : 0

export const nextInvoiceNumber = () => `РФ-0${proto.state.nextInvoiceNumber}`
